export const DESKTOP_MQ = "(min-width: 1024px) and (pointer: fine) and (hover: hover)"

// Wide-but-short touch viewports: iPhone landscape (~844×390). Portrait phones
// stay below 667px width; iPad portrait/landscape stays above 500px height.
export const LANDSCAPE_PHONE_MQ = "(min-width: 667px) and (max-height: 500px) and (pointer: coarse)"

// iPad portrait (~768×1024) and other touch tablets: wide enough for a left rail.
// hover:none catches touch-primary iPads; max-width covers sub-1024 viewports when
// Safari reports fine pointer / hover (portrait width < desktop breakpoint).
// min-height excludes iPhone landscape (~844×390).
export const TABLET_TOUCH_MQ = "(min-width: 768px) and (min-height: 501px) and ((hover: none) or (max-width: 1023.98px))"

export const SIDEBAR_LAYOUT_MQ = `${DESKTOP_MQ}, ${LANDSCAPE_PHONE_MQ}, ${TABLET_TOUCH_MQ}`

// Inside the Hotwire Native wrapper, iPads get the split layout too (the CSS
// no longer gates the left rail on body:not(.turbo-native)); native phones are
// portrait-locked and never match these queries.
export function usesSidebarLayout() {
    return window.matchMedia(SIDEBAR_LAYOUT_MQ).matches
}
